export enum CallFiltersState {
  ALL_CALLS = 'ALL_CALLS',
  MY_CALLS = 'MY_CALLS',
  STATUS = 'STATUS',
  DATE_RANGE = 'DATE_RANGE',
  TAGS = 'TAGS',
  ASSIGNEE = 'ASSIGNEE',
  WABA = 'WABA',
  NONE = 'NONE',
}
